export type IIapProductType = 'consumable' | 'recurring';

export type IIapProductCurrency = 'eur' | 'usd';

export type IIapProductPrice = Record<IIapProductCurrency, number>;

export type IIapProduct = {
  _id: string;
  type: IIapProductType;
  customerPrice: IIapProductPrice;
  proceeds: IIapProductPrice;
};

export const iapProducts: Array<IIapProduct> = [
  {
    _id: 'article_01',
    type: 'consumable',
    customerPrice: {
      eur: 990000,
      usd: 990000,
    },
    proceeds: {
      eur: 580000,
      usd: 700000,
    },
  },
  {
    _id: 'article_02',
    type: 'consumable',
    customerPrice: {
      eur: 1990000,
      usd: 1990000,
    },
    proceeds: {
      eur: 1160000,
      usd: 1400000,
    },
  },
  {
    _id: 'article_03',
    type: 'consumable',
    customerPrice: {
      eur: 2990000,
      usd: 2990000,
    },
    proceeds: {
      eur: 1740000,
      usd: 2100000,
    },
  },
  {
    _id: 'article_04',
    type: 'consumable',
    customerPrice: {
      eur: 3990000,
      usd: 3990000,
    },
    proceeds: {
      eur: 2320000,
      usd: 2800000,
    },
  },
  {
    _id: 'article_05',
    type: 'consumable',
    customerPrice: {
      eur: 4990000,
      usd: 4990000,
    },
    proceeds: {
      eur: 2900000,
      usd: 3500000,
    },
  },
  {
    _id: 'article_06',
    type: 'consumable',
    customerPrice: {
      eur: 5990000,
      usd: 5990000,
    },
    proceeds: {
      eur: 3480000,
      usd: 4200000,
    },
  },
  {
    _id: 'article_07',
    type: 'consumable',
    customerPrice: {
      eur: 6990000,
      usd: 6990000,
    },
    proceeds: {
      eur: 4060000,
      usd: 4900000,
    },
  },
  {
    _id: 'article_08',
    type: 'consumable',
    customerPrice: {
      eur: 7990000,
      usd: 7990000,
    },
    proceeds: {
      eur: 4640000,
      usd: 5600000,
    },
  },
  {
    _id: 'article_09',
    type: 'consumable',
    customerPrice: {
      eur: 8990000,
      usd: 8990000,
    },
    proceeds: {
      eur: 5220000,
      usd: 6300000,
    },
  },
  {
    _id: 'article_10',
    type: 'consumable',
    customerPrice: {
      eur: 9990000,
      usd: 9990000,
    },
    proceeds: {
      eur: 5800000,
      usd: 7000000,
    },
  },
  {
    _id: 'article_11',
    type: 'consumable',
    customerPrice: {
      eur: 10990000,
      usd: 10990000,
    },
    proceeds: {
      eur: 6380000,
      usd: 7700000,
    },
  },
  {
    _id: 'article_12',
    type: 'consumable',
    customerPrice: {
      eur: 11990000,
      usd: 11990000,
    },
    proceeds: {
      eur: 6960000,
      usd: 8400000,
    },
  },
  {
    _id: 'article_13',
    type: 'consumable',
    customerPrice: {
      eur: 12990000,
      usd: 12990000,
    },
    proceeds: {
      eur: 7540000,
      usd: 9100000,
    },
  },
  {
    _id: 'article_14',
    type: 'consumable',
    customerPrice: {
      eur: 13990000,
      usd: 13990000,
    },
    proceeds: {
      eur: 8120000,
      usd: 9800000,
    },
  },
  {
    _id: 'article_15',
    type: 'consumable',
    customerPrice: {
      eur: 14990000,
      usd: 14990000,
    },
    proceeds: {
      eur: 8700000,
      usd: 10500000,
    },
  },
  {
    _id: 'article_16',
    type: 'consumable',
    customerPrice: {
      eur: 15990000,
      usd: 15990000,
    },
    proceeds: {
      eur: 9280000,
      usd: 11200000,
    },
  },
  {
    _id: 'article_17',
    type: 'consumable',
    customerPrice: {
      eur: 16990000,
      usd: 16990000,
    },
    proceeds: {
      eur: 9860000,
      usd: 11900000,
    },
  },
  {
    _id: 'article_18',
    type: 'consumable',
    customerPrice: {
      eur: 17990000,
      usd: 17990000,
    },
    proceeds: {
      eur: 10440000,
      usd: 12600000,
    },
  },
  {
    _id: 'article_19',
    type: 'consumable',
    customerPrice: {
      eur: 18990000,
      usd: 18990000,
    },
    proceeds: {
      eur: 11020000,
      usd: 13300000,
    },
  },
  {
    _id: 'article_20',
    type: 'consumable',
    customerPrice: {
      eur: 19990000,
      usd: 19990000,
    },
    proceeds: {
      eur: 11600000,
      usd: 14000000,
    },
  },
  {
    _id: 'article_21',
    type: 'consumable',
    customerPrice: {
      eur: 29990000,
      usd: 29990000,
    },
    proceeds: {
      eur: 17400000,
      usd: 21000000,
    },
  },
  {
    _id: 'article_22',
    type: 'consumable',
    customerPrice: {
      eur: 39990000,
      usd: 39990000,
    },
    proceeds: {
      eur: 23200000,
      usd: 28000000,
    },
  },
  {
    _id: 'article_23',
    type: 'consumable',
    customerPrice: {
      eur: 49990000,
      usd: 49990000,
    },
    proceeds: {
      eur: 29000000,
      usd: 35000000,
    },
  },
  {
    _id: 'subscription_01',
    type: 'recurring',
    customerPrice: {
      eur: 990000,
      usd: 990000,
    },
    proceeds: {
      eur: 580000,
      usd: 700000,
    },
  },
  {
    _id: 'subscription_02',
    type: 'recurring',
    customerPrice: {
      eur: 1990000,
      usd: 1990000,
    },
    proceeds: {
      eur: 1160000,
      usd: 1400000,
    },
  },
  {
    _id: 'subscription_03',
    type: 'recurring',
    customerPrice: {
      eur: 2990000,
      usd: 2990000,
    },
    proceeds: {
      eur: 1740000,
      usd: 2100000,
    },
  },
  {
    _id: 'subscription_04',
    type: 'recurring',
    customerPrice: {
      eur: 3990000,
      usd: 3990000,
    },
    proceeds: {
      eur: 2320000,
      usd: 2800000,
    },
  },
  {
    _id: 'subscription_05',
    type: 'recurring',
    customerPrice: {
      eur: 4990000,
      usd: 4990000,
    },
    proceeds: {
      eur: 2900000,
      usd: 3500000,
    },
  },
  {
    _id: 'subscription_06',
    type: 'recurring',
    customerPrice: {
      eur: 5990000,
      usd: 5990000,
    },
    proceeds: {
      eur: 3480000,
      usd: 4200000,
    },
  },
  {
    _id: 'subscription_07',
    type: 'recurring',
    customerPrice: {
      eur: 6990000,
      usd: 6990000,
    },
    proceeds: {
      eur: 4060000,
      usd: 4900000,
    },
  },
  {
    _id: 'subscription_08',
    type: 'recurring',
    customerPrice: {
      eur: 7990000,
      usd: 7990000,
    },
    proceeds: {
      eur: 4640000,
      usd: 5600000,
    },
  },
  {
    _id: 'subscription_09',
    type: 'recurring',
    customerPrice: {
      eur: 8990000,
      usd: 8990000,
    },
    proceeds: {
      eur: 5220000,
      usd: 6300000,
    },
  },
  {
    _id: 'subscription_10',
    type: 'recurring',
    customerPrice: {
      eur: 9990000,
      usd: 9990000,
    },
    proceeds: {
      eur: 5800000,
      usd: 7000000,
    },
  },
  {
    _id: 'subscription_11',
    type: 'recurring',
    customerPrice: {
      eur: 10990000,
      usd: 10990000,
    },
    proceeds: {
      eur: 6380000,
      usd: 7700000,
    },
  },
  {
    _id: 'subscription_12',
    type: 'recurring',
    customerPrice: {
      eur: 11990000,
      usd: 11990000,
    },
    proceeds: {
      eur: 6960000,
      usd: 8400000,
    },
  },
  {
    _id: 'subscription_13',
    type: 'recurring',
    customerPrice: {
      eur: 12990000,
      usd: 12990000,
    },
    proceeds: {
      eur: 7540000,
      usd: 9100000,
    },
  },
  {
    _id: 'subscription_14',
    type: 'recurring',
    customerPrice: {
      eur: 13990000,
      usd: 13990000,
    },
    proceeds: {
      eur: 8120000,
      usd: 9800000,
    },
  },
  {
    _id: 'subscription_15',
    type: 'recurring',
    customerPrice: {
      eur: 14990000,
      usd: 14990000,
    },
    proceeds: {
      eur: 8700000,
      usd: 10500000,
    },
  },
  {
    _id: 'subscription_16',
    type: 'recurring',
    customerPrice: {
      eur: 15990000,
      usd: 15990000,
    },
    proceeds: {
      eur: 9280000,
      usd: 11200000,
    },
  },
  {
    _id: 'subscription_17',
    type: 'recurring',
    customerPrice: {
      eur: 16990000,
      usd: 16990000,
    },
    proceeds: {
      eur: 9860000,
      usd: 11900000,
    },
  },
  {
    _id: 'subscription_18',
    type: 'recurring',
    customerPrice: {
      eur: 17990000,
      usd: 17990000,
    },
    proceeds: {
      eur: 10440000,
      usd: 12600000,
    },
  },
  {
    _id: 'subscription_19',
    type: 'recurring',
    customerPrice: {
      eur: 18990000,
      usd: 18990000,
    },
    proceeds: {
      eur: 11020000,
      usd: 13300000,
    },
  },
  {
    _id: 'subscription_20',
    type: 'recurring',
    customerPrice: {
      eur: 19990000,
      usd: 19990000,
    },
    proceeds: {
      eur: 11600000,
      usd: 14000000,
    },
  },
  {
    _id: 'subscription_21',
    type: 'recurring',
    customerPrice: {
      eur: 29990000,
      usd: 29990000,
    },
    proceeds: {
      eur: 17400000,
      usd: 21000000,
    },
  },
  {
    _id: 'subscription_22',
    type: 'recurring',
    customerPrice: {
      eur: 39990000,
      usd: 39990000,
    },
    proceeds: {
      eur: 23200000,
      usd: 28000000,
    },
  },
  {
    _id: 'subscription_23',
    type: 'recurring',
    customerPrice: {
      eur: 49990000,
      usd: 49990000,
    },
    proceeds: {
      eur: 29000000,
      usd: 35000000,
    },
  },
  {
    _id: 'subscription_24',
    type: 'recurring',
    customerPrice: {
      eur: 24990000,
      usd: 24990000,
    },
    proceeds: {
      eur: 14580000,
      usd: 17500000,
    },
  },
];
